import { ApiCreateExpense, ApiDeleteExpense, ApiGetExpenseById, ApiGetExpenseList, ApiUpdateExpense } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function ExpenseService() {
    const { showFail } = useModal()

    const { fetch: apiGetExpenseList } = useFetch(ApiGetExpenseList)
    const { fetch: apiGetExpenseById } = useFetch(ApiGetExpenseById)
    const { fetch: apiDeleteExpense } = useFetch(ApiDeleteExpense)
    const { fetch: apiCreateExpense } = useFetch(ApiCreateExpense)
    const { fetch: apiUpdateExpense } = useFetch(ApiUpdateExpense)

    const fetchExpenseList = async(dateFrom, dateTo, expenseCategoryId, description, status, pageSize, index) => {
        const res = await apiGetExpenseList({
            data: {
                dateFrom,
                dateTo,
                expenseCategoryId,
                description,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchExpenseById = async(expenseId) => {
        const res = await apiGetExpenseById({
            data: {
                expenseId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteExpense = async(expenseId, status) => {
        const res = await apiDeleteExpense({
            data: {
                expenseId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateExpense = async(expenseCategoryId, amount, description, expenseDate) => {
        const res = await apiCreateExpense({
            data: {
                expenseCategoryId,
                amount, 
                description,
                expenseDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateExpense = async(expenseId, expenseCategoryId, amount, description, expenseDate) => {
        const res = await apiUpdateExpense({
            data: {
                expenseId,
                expenseCategoryId,
                amount, 
                description,
                expenseDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchExpenseList,
        fetchExpenseById,
        fetchDeleteExpense,
        fetchCreateExpense,
        fetchUpdateExpense
    }
}